import * as angular from "angular";
import {IController} from "angular";

export class TaskNoteInfoIconCtrl implements IController {
  taskSpec: any;
}

angular
  .module('bringoz.admin.tasks')
  .component('taskNoteInfoIcon', {
    bindings: {
      taskSpec: '<'
    },
    template: require('./task-note-info-icon.html').default,
    controller: TaskNoteInfoIconCtrl
  });
